var render = function render(){var _vm=this,_c=_vm._self._c;return ((_vm.data.state < 2))?_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-6"},[_c('router-link',{staticClass:"font-weight-bold rounded-50 btn btn-block btn-primary text-white",attrs:{"to":{ name: _vm.link, params:{fromDisplay:true} }}},[_vm._v(_vm._s(_vm.text))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }